export enum AdminRoutes {
  ROOT = '',
  USERS = 'users',
  USERS_STATS = 'users-stats',
  USER = 'user',
  RATINGS = 'ratings',
  REGISTRATIONS = 'registrations'
}
